import { RelevantFulfillmentGroupNotFoundReason } from "@redotech/redo-merchant-fulfillment-rpc/schema/get-relevant-fulfillment-group-data";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { memo } from "react";

const TITLE_BY_REASON: Record<RelevantFulfillmentGroupNotFoundReason, string> =
  {
    NOT_FOUND: "Shipment not found",
    NO_ITEMS: "Shipment has no items",
    CANCELLED: "Shipment cancelled",
    VOIDED: "Shipment voided",
    CLOSED: "Shipment already closed",
    NO_DELIVERY_METHOD: "Shipment unavailable",
  };

const BODY_BY_REASON: Record<
  RelevantFulfillmentGroupNotFoundReason,
  (barcode: string) => string
> = {
  NOT_FOUND: (barcode) =>
    `No shipment found for "${barcode}". Double-check the barcode and try again.`,
  NO_ITEMS: () =>
    "This shipment has no items to fulfill, so it can't be opened from the scan page.",
  CANCELLED: () => "This shipment was cancelled.",
  VOIDED: () => "This shipment was voided.",
  CLOSED: () => "This shipment is already closed.",
  NO_DELIVERY_METHOD: () =>
    "This shipment has no delivery method, so it can't be fulfilled here.",
};

export const ShipmentNotFoundModal = memo(function ShipmentNotFoundModal({
  barcode,
  reason,
  onClose,
}: {
  barcode: string;
  reason: RelevantFulfillmentGroupNotFoundReason;
  onClose: () => void;
}) {
  return (
    <RedoModal
      onModalCloseRequested={onClose}
      primaryButton={{ onClick: onClose, text: "Close" }}
      title={TITLE_BY_REASON[reason]}
    >
      {BODY_BY_REASON[reason](barcode)}
    </RedoModal>
  );
});
